import { Object, String, Static, Record, Optional, Number } from '@sinclair/typebox';

export type Pod = Static<typeof Pod>;
export const Pod = Object({
  name: String(),
  status: Optional(String()),
});

const resource = Object({
  cpu: Optional(String()),
  memory: Optional(String()),
});

const DeploymentResource = Object({
  limits: Optional(resource),
  requests: Optional(resource),
});

export type Deployment = Static<typeof Deployment>;
export const Deployment = Object({
  id: String(),
  name: String(),
  selector: Record(String(), String()),
  repository: Optional(String()),
  image: Optional(String()),
  revision: Optional(String()),
  availableReplicas: Optional(Number()),
  resources: Optional(DeploymentResource),
});
